import { CancelButton, SaveButton } from '@core/components/Buttons';
import { FormDialogContent, SimpleDialog } from '@core/components/Dialog';
import { DateInput, TextInput } from '@core/components/Inputs';
import { SimpleTableBase } from '@core/components/Table';
import { TableActionButton } from '@core/components/TableAction';
import { useReduxLoading } from '@core/hooks';
import { useApiUtils } from '@core/util/apiUtils';
import { mensagemCampoObrigatorio } from '@core/util/mensagemUtil';
import { Divider, Grid, TextField, Tooltip, Typography } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { withStyles } from '@material-ui/core/styles';
import { Note } from '@material-ui/icons';
import { Autocomplete } from '@material-ui/lab';
import { cancelarAlert, confirmarAlert } from 'app/services/alerts';
import { fechamentoPeriodoApi } from 'app/services/api/fechamentoPeriodoApi';
import * as Actions from 'app/store/actions';
import { GlobalContext } from 'app/store/globalcontext';
import { getEmpresaContexto } from 'app/utils/geralUtil';
import { FormikProvider, useFormik } from 'formik';
import moment from 'moment';
import React, { useContext, useEffect } from 'react';
import { FaInfoCircle, FaLock } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import * as Yup from 'yup';
import ModalEditarNotaExplicativa from '../modal/ModalEditarNotaExplicativa';
import { PeriodoFechadoModais } from '../modal/PeriodoFechadoModais';
import { PeriodoFechadoContext, PeriodoFechadoProvider } from '../store/PeriodoFechadoContext';

const FechamentoPeriodoForm = ({ formik, options, fetchHistorico, totalElements, historico, setPage, setSize }) => {
  const [, setSort] = useContext(PeriodoFechadoContext).sort;
  const [, setModal] = useContext(PeriodoFechadoContext).modal;
  const [loading] = useContext(PeriodoFechadoContext).loading;
  const [, setPeriodoFechadoNota] = useContext(PeriodoFechadoContext).periodoFechadoNota;

  useReduxLoading(loading);

  const styles = {
    tooltip: {
      width: '250px',
    },
  };

  const CustomTooltip = withStyles(styles)(Tooltip);

  const handlerTitle = (funcionalidades) => {
    let tip = [];

    funcionalidades.forEach((funcionalidade) => {
      if (funcionalidade === 'COMPRAS_PAGAMENTO') {
        tip.push('Compras e Pagamentos');
      } else if (funcionalidade === 'RECEBIMENTOS_VENDAS') {
        tip.push('Recebimentos e Vendas');
      } else if (funcionalidade === 'TRANSFERENCIAS') {
        tip.push('Transferências');
      }
    });

    return tip.join('\n');
  };

  useEffect(() => {
    fetchHistorico();
    // Memoização intencional: as funções/props são recriadas a cada render e incluí-las
    // anularia o memo; o estado que elas leem já está nas dependências.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const columns = [
    {
      name: 'mesFechamento',
      title: 'Mês de fechamento',
      align: 'left',
      hideTooltip: true,
      getCellValue: (option) => {
        return (
          <div style={{ display: 'flex', justifyContent: 'left', alignItems: 'center' }}>
            {moment(option?.periodo).format('MMMM/YYYY')}
            <div style={{ display: 'flex', flexDirection: 'row', marginLeft: 5 }}>
              <Tooltip
                title={<div style={{ whiteSpace: 'pre-line' }}>{handlerTitle(option?.funcionalidades)}</div>}
                placement="bottom"
              >
                <div>
                  <FaInfoCircle size={15} style={{ color: 'rgb(121, 166, 187)' }} />
                </div>
              </Tooltip>
            </div>
          </div>
        );
      },
      sortingEnabled: false,
    },
    {
      name: 'dataHora',
      title: 'Data - Hora',
      align: 'center',
      getCellValue: (option) => moment(option?.dataHora).format('DD/MM/YYYY - HH:mm'),
      sortingEnabled: false,
    },
    {
      name: 'responsavel',
      title: 'Responsável',
      align: 'left',
      getCellValue: (option) => option?.responsavel,
      sortingEnabled: false,
    },
    {
      name: '',
      title: '',
      sortingEnabled: false,
      align: 'left',
      width: 90,
      getCellValue: (option) => {
        return (
          <TableActionButton
            title="Editar nota explicativa"
            icon={<Note size={10} style={{ fontSize: '0.5em' }} />}
            onClick={() => handlerEditar(option)}
          />
        );
      },
    },
  ];

  const handlerEditar = (option) => {
    setPeriodoFechadoNota(option);
    setModal(PeriodoFechadoModais.editarNotaExplicativa);
  };

  const _errors = {
    periodo: (formik.submitCount > 0 || formik.touched?.periodo) && formik.errors?.periodo,
    funcionalidades: (formik.submitCount > 0 || formik.touched?.funcionalidades) && formik.errors?.funcionalidades,
  };

  const listaFuncionalidades = [
    { id: 'COMPRAS_PAGAMENTO', nome: 'Compras e Pagamentos' },
    { id: 'RECEBIMENTOS_VENDAS', nome: 'Recebimentos e Vendas' },
    { id: 'TRANSFERENCIAS', nome: 'Transferências' },
  ];

  const hintPeriodo =
    'O sistema não permitirá baixas e cancelamentos de baixas de contas a pagar e contas a receber, entradas ' +
    'e saídas de estoque e transferências até esta data, conforme a funcionalidade selecionada. Caso informe um ' +
    'mês menor que o último fechado, o sistema automaticamente abrirá os meses posteriores à data informada.';

  const hintFuncionalidades = 'Selecione aqui quais funcionalidades você deseja realizar o fechamento.';

  const hintBloquearAnteriores =
    'O sistema não permitirá lançamentos, edições e exclusões de contas a receber, contas a pagar, compras, vendas ' +
    'e contratos até o período informado, conforme funcionalidade selecionada. Obs.: Contratos é considerado na ' +
    'funcionalidade "Recebimentos e Vendas".';

  return (
    <>
      <Grid container spacing={3} style={{ justifyContent: 'center', alignItems: 'center' }}>
        <Grid
          container
          spacing={3}
          style={{ width: '100%', display: 'flex', flexDirection: 'row', marginBottom: 1, marginTop: 1 }}
        >
          <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
            <Grid style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', marginBottom: 5 }}>
              <Tooltip title={hintPeriodo} placement="right-end">
                <div>
                  <FaInfoCircle size={18} style={{ color: '#f2994a' }} />
                </div>
              </Tooltip>
            </Grid>
            <DateInput
              id="periodo"
              inputVariant="outlined"
              label="Fechar período até"
              value={formik.values?.periodo}
              error={_errors.periodo}
              helperText={!!_errors.periodo && _errors.periodo}
              touched={!!_errors.periodo}
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              format="MM/YYYY"
              openTo="month"
              views={['month', 'year']}
              cancelLabel={false}
              okLabel={false}
              autoOk
              //autoFocus
              required
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
            <Grid style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', marginBottom: 5 }}>
              <Tooltip title={hintFuncionalidades} placement="left-end">
                <div>
                  <FaInfoCircle size={18} style={{ color: '#f2994a' }} />
                </div>
              </Tooltip>
            </Grid>
            <Autocomplete
              multiple
              id="funcionalidades"
              value={formik.values.funcionalidades}
              onChange={(event, newValue) => {
                formik.setFieldValue('funcionalidades', [
                  ...options,
                  ...newValue.filter((value) => options.indexOf(value) === -1),
                ]);
              }}
              limitTags={1}
              onBlur={formik.handleBlur}
              options={listaFuncionalidades}
              getOptionLabel={(option) => option.nome}
              getOptionDisabled={(option) => {
                let selecionado = false;

                if (formik.values.funcionalidades.some((value) => value.id === option.id)) {
                  selecionado = true;
                }

                return selecionado;
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  label="Funcionalidades"
                  touched={!!_errors.funcionalidades}
                  error={_errors.funcionalidades}
                  helperText={!!_errors.funcionalidades && _errors.funcionalidades}
                  required
                  InputLabelProps={{ shrink: true }}
                />
              )}
            />
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <TextInput
            id="notaExplicativa"
            label="Nota explicativa"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.notaExplicativa}
            fullWidth
            variant="outlined"
            maxLength={500}
            rows={4}
            multiline
          />
        </Grid>
        <Grid item xs={12} style={{ display: 'flex', alignItems: 'center' }}>
          <FormControlLabel
            control={
              <Checkbox
                color="primary"
                name="bloquearAnteriores"
                checked={formik.values.bloquearAnteriores}
                value={formik.values.bloquearAnteriores}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
            }
            label="Bloquear lançamentos anteriores à essa data."
          />
          <CustomTooltip title={hintBloquearAnteriores} placement="right">
            <div>
              <FaInfoCircle size={18} style={{ color: '#f2994a' }} />
            </div>
          </CustomTooltip>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Typography style={{ marginRight: 16, fontSize: 18, textTransform: 'initial' }} variant="button">
            Histórico
          </Typography>
          <Divider />
        </Grid>
        <div style={{ width: '59rem' }}>
          <SimpleTableBase
            getRowId={(row) => row}
            fetchOnCreate={false}
            defaultSorting={[{ columnName: 'dataHora', direction: 'desc' }]}
            columns={columns}
            hideSelection
            rows={historico}
            loading={loading}
            totalCount={totalElements}
            fetchData={fetchHistorico}
            onCurrentPageChange={setPage}
            onPageSizeChange={setSize}
            onSortingChange={setSort}
          />
        </div>
      </Grid>
    </>
  );
};

const FechamentoPeriodoModal = () => {
  const options = [];
  const [loading, setLoading] = useContext(PeriodoFechadoContext).loading;
  const [modal, setModal] = useContext(GlobalContext).modal;
  const [totalElements, setTotalElements] = useContext(PeriodoFechadoContext).totalElements;
  const [historico, setHistorico] = useContext(PeriodoFechadoContext).historico;
  const [, setPage] = useContext(PeriodoFechadoContext).page;
  const [, setSize] = useContext(PeriodoFechadoContext).size;

  useReduxLoading(loading);

  const initialPage = {
    page: 0,
    q: '',
    size: 15,
    sort: 'dataHora,DESC',
  };

  const fetchHistorico = async (search = initialPage) => {
    try {
      setLoading(true);
      const response = await fechamentoPeriodoApi.buscarHistorico(search);

      if (response?.status === 200 || response.status === 201) {
        setPage(response.data.number);
        setSize(response.data.size);
        setTotalElements(response.data.totalElements);
        setHistorico(response.data.content);
        setTotalElements(response.data.totalElements);
      }
    } catch (err) {
      console.error(err);
      apiUtils.handleApiError(err);
    } finally {
      setLoading(false);
    }
  };

  const dispatch = useDispatch();
  const apiUtils = useApiUtils(dispatch, Actions);

  const showSuccess = (message) => {
    dispatch(Actions.showMessage({ message, variant: 'success' }));
  };

  const verificarPeriodo = (data) => {
    if (!data || !data.date) {
      return true;
    }

    const amanha = moment().add(1, 'day');

    return amanha.isAfter(data);
  };

  const handleCloseModal = () => {
    const close = () => {
      formik.resetForm(initialValues);
      setModal(false);
    };

    const periodoFoiModificado = formik.values.periodo.format('MM/YYYY') !== moment().format('MM/YYYY') ? true : false;
    const funcionalidadeFoiModificada = formik.values.funcionalidades.length !== 0 ? true : false;
    const notaFoiModificada = formik.values.notaExplicativa !== '' ? true : false;
    const bloquearAnterioresFoiModificado = formik.values.bloquearAnteriores;

    if (periodoFoiModificado || funcionalidadeFoiModificada || notaFoiModificada || bloquearAnterioresFoiModificado) {
      cancelarAlert({
        confirmar: close,
      });
    } else {
      close();
    }
  };

  const initialValues = {
    periodo: moment(),
    funcionalidades: [...options],
    notaExplicativa: '',
    bloquearAnteriores: false,
  };

  const handleSubmit = async () => {
    const empresaId = getEmpresaContexto();

    const funcionalidadesSelecionadas = formik.values?.funcionalidades.map((funcionalidade) => {
      return funcionalidade.id;
    });

    const obj = {
      empresaId,
      periodo: formik.values?.periodo,
      funcionalidades: funcionalidadesSelecionadas,
      notaExplicativa: formik.values?.notaExplicativa,
      bloquearAnteriores: formik.values?.bloquearAnteriores,
    };

    let title = 'Confirma o fechamento do período até ' + formik.values.periodo.format('MM/YYYY') + '?';
    confirmarAlert({
      opcoes: {
        title,
      },
      confirmar: async () => {
        setLoading(true);
        try {
          const response = await fechamentoPeriodoApi.criar(obj);

          if (response?.status === 200 || response.status === 201) {
            showSuccess('Fechamento do período salvo com sucesso.');
          }
        } catch (err) {
          console.error(err);
          apiUtils.handleApiError(err);
        } finally {
          setLoading(false);
          setModal(false);
        }
      },
    });
  };

  const periodoFechadoSchema = Yup.object().shape({
    periodo: Yup.object()
      .nullable()
      .test('periodo', 'O mês de fechamento não pode ser maior que o mês atual', verificarPeriodo)
      .required(mensagemCampoObrigatorio('o período')),
    funcionalidades: Yup.string()
      .nullable()
      .required(mensagemCampoObrigatorio('as funcionalidades')),
  });

  const formik = useFormik({
    onSubmit: handleSubmit,
    validationSchema: periodoFechadoSchema,
    initialValues,
    validateOnBlur: true,
    validateOnChange: true,
  });

  return (
    <SimpleDialog open={modal === 'fechamentoPeriodo'} onClose={handleCloseModal} innerScroll>
      <FormikProvider value={formik}>
        <FormDialogContent
          onSubmit={formik.handleSubmit}
          header={{
            title: 'Fechamento do período',
            icon: <FaLock />,
            toolbar: (
              <>
                <CancelButton onClick={handleCloseModal}>Cancelar</CancelButton>
                <SaveButton color="buttonSave" type="submit">
                  Salvar
                </SaveButton>
              </>
            ),
          }}
          content={
            <>
              <FechamentoPeriodoForm
                formik={formik}
                options={options}
                loading={loading}
                fetchHistorico={fetchHistorico}
                totalElements={totalElements}
                historico={historico}
                setPage={setPage}
                setSize={setSize}
              />
              <ModalEditarNotaExplicativa fetchHistorico={fetchHistorico} />
            </>
          }
        />
      </FormikProvider>
    </SimpleDialog>
  );
};

const FechamentoPeriodo = () => {
  return (
    <PeriodoFechadoProvider>
      <FechamentoPeriodoModal />
    </PeriodoFechadoProvider>
  );
};

export default FechamentoPeriodo;
